const resolveComposerScopeKey = ({ scopeKey, threadId } = {}) => {
  const sk = String(scopeKey || '').trim();
  if (sk) {
    return sk;
  }
  const tid = String(threadId || '').trim();
  if (tid) {
    return `thread:${tid}`;
  }
  return 'active';
};

export default resolveComposerScopeKey;
